import {ColumnData, ValueColumn} from '../../dashboard/models/chart';
import {ConditionalColorType} from '../../dashboard/models/conditional-color.type';
import * as chroma from 'chroma-js';

export class ConditionalColoringHelper {
  public static generateConditionalFormattingColorScale(chartColumn: Partial<ValueColumn>,
                                                        conditionalFormattingColumn: ColumnData, type: ConditionalColorType,
                                                        conditionalColoringMode: 'single' | 'range') {
    let colorScale;
    if (conditionalFormattingColumn) {
      let minValue = ConditionalColoringHelper.getConditionalFormattingValue(
        chartColumn.conditionalFormatting[type].hasCustomMin,
        chartColumn.conditionalFormatting[type].minValue,
        conditionalFormattingColumn['conditionalFormattingValue' + (type === 'valueColor' ? 'Color' : '')]?.minValue,
        Number.MIN_VALUE);
      let maxValue = ConditionalColoringHelper.getConditionalFormattingValue(
        chartColumn.conditionalFormatting[type].hasCustomMax,
        chartColumn.conditionalFormatting[type].maxValue,
        conditionalFormattingColumn['conditionalFormattingValue' + (type === 'valueColor' ? 'Color' : '')]?.maxValue,
        Number.MAX_VALUE);

      // Correct min and max if they are swapped
      if (minValue > maxValue) {
        [minValue, maxValue] = [maxValue, minValue];
      }

            let averageValue: number | undefined = ConditionalColoringHelper.getConditionalFormattingValue(
            chartColumn.conditionalFormatting[type].hasCustomMiddle,
            chartColumn.conditionalFormatting[type].middleValue,
            conditionalFormattingColumn['conditionalFormattingValue' + (type === 'valueColor' ? 'Color' : '')]?.averageValue,
            0);

      // ignore average if out of range
      if (averageValue < minValue || averageValue > maxValue) {
        averageValue = undefined;
      }

      const minColor = chartColumn.conditionalFormatting[type].minColor;
      const middleColor = chartColumn.conditionalFormatting[type].middleColor;
      const maxColor = chartColumn.conditionalFormatting[type].maxColor;

      if (chartColumn.conditionalFormatting[type].hasDiverging) {
        // diverging logic
        if (conditionalColoringMode === 'single') {
          colorScale = {
            min: { value: minValue, color: minColor },
            max: { value: maxValue, color: maxColor },
            average: averageValue ? { value: averageValue, color: middleColor } : undefined,
          };
        } else {
          colorScale = averageValue !== undefined
            ? chroma.scale([minColor, middleColor, maxColor]).domain([minValue, averageValue, maxValue])
            : chroma.scale([minColor, maxColor]).domain([minValue, maxValue]);
        }
      } else {
        // non-diverging logic
        if (conditionalColoringMode === 'single') {
          colorScale = {
            min: { value: minValue, color: minColor },
            max: { value: maxValue, color: maxColor },
          };
        } else {
          colorScale = chroma.scale([minColor, maxColor]).domain([minValue, maxValue]);
        }
      }
    }
    return colorScale;
  }

  public static getConditionalFormattingValue(hasCustom: boolean, customValue: number,
                                              conditionalValue: number, defaultValue: number): number {
    const hasCustomValue = hasCustom && customValue !== null && customValue !== undefined && !isNaN(customValue);
    const hasConditionalValue = conditionalValue !== undefined && conditionalValue !== null && !isNaN(conditionalValue);
    return hasCustomValue ? customValue : (hasConditionalValue ? conditionalValue : defaultValue);
  }

  public static pickSingleColor(colorScale: any, value: any, defaultColor?: string){
    if(colorScale.average){
      if(value>colorScale.min.value && value<colorScale.max.value){
        return colorScale.average.color;
      } else if(value>=colorScale.max.value){
        return colorScale.max.color;
      }else if(value<=colorScale.min.value){
        return colorScale.min.color;
      }
    }else{
      if(value>=colorScale.max.value){
        return colorScale.max.color;
      }else if(value<=colorScale.min.value){
        return colorScale.min.color;
      }
      return defaultColor;
    }
  }
}
